import React from 'react';
import { useTranslation } from 'react-i18next';
import PieChart from '../../charts/PieChart'
import { useGetAppSdkVersionQuery } from '../../../api/appApiSlice';
import BlockChart from '../../BlockChart';
import versionCompare from '../../../services/versionCompare';

const DevicePerSdkVersion = ({appId, filter, ...props}) => {
  const { t } = useTranslation();
  const { data = [], isSuccess, isLoading, refetch } = useGetAppSdkVersionQuery({appId, filter})
  const pieData = [...data].sort((a,b) => versionCompare(b.sdk_version,a.sdk_version) ).map((x)=>({"name":x.sdk_version,"y":x.active_devices}))

  return (
    <BlockChart title={t('version.device_per_sdk_version')} isSuccess={isSuccess} isLoading={isLoading} retry={refetch}  {...props}>
      <PieChart data={pieData} legendOptions={{show: false}} datalabels/>
    </BlockChart>
  )
}

export default DevicePerSdkVersion